import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import { useDialog } from 'components/Modals';
import { AuthContext } from 'contexts/AuthContext';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Rubrica = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const { user } = useContext(AuthContext);
  const rubricas = pessoal?.Rubricas ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalRubrica',
      id: item?.id,
      pessoal_id: pessoal?.id,
      rubrica_id: item?.rubrica_id || null,
      ano: item?.ano || '',
      mes: item?.mes || '',
      valor: item?.valor || '',
      roteiro_id: item?.roteiro_id || null,
      users_id: item?.users_id || user?.id,
      datahora: item?.datahora || moment().format('YYYY-MM-DD HH:mm:ss'),
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação da Rúbrica" disableMargin />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            label="Rúbrica"
            name="rubrica_id"
            control={control}
            options={drops?.Rubrica}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="mes" control={control} label="Mês de Referência" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="ano" control={control} label="Ano de Referência" />
        </Grid>
        <Grid item xs={12}>
          <Title title="Valores" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="valor" label="Valor" control={control} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="roteiro_id"
            control={control}
            options={drops?.Roteiro}
            label="Roteiro de Cálculo"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Rúbricas"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Rúbrica')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={rubricas}
          columns={[
            {
              field: 'rubrica',
              headerName: 'Rúbrica',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'mes',
              headerName: 'Mês',
              width: 100,
              sortable: false,
            },
            {
              field: 'ano',
              headerName: 'Ano',
              width: 100,
              sortable: false,
            },
            {
              field: 'valor',
              headerName: 'Valor',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value &&
                value?.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                }),
            },
            {
              field: 'roteiro',
              headerName: 'Roteiro de Cálculo',
              width: 300,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Rúbrica')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalRubrica', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Rubrica;
